var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.bookingTermsAreAccepted
    ? _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "paymentItem",
              attrs: { to: _vm.paymentRouterLinkAction },
            },
            [
              _c("div", { staticClass: "paymentItem_main" }, [
                _c("div", { staticClass: "paymentItem_header" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.bookingPaymentType))]),
                  _vm._v(" "),
                  _vm.canEditPaymentDueDate
                    ? _c(
                        "button",
                        {
                          staticClass: "paymentItem_editButton",
                          attrs: {
                            type: "button",
                            "data-toggle": "modal",
                            "data-target": _vm.dueDateModalId,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-edit" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _vm.bookingPaymentIsOverdue
                      ? _c("span", { staticClass: "label label-danger" }, [
                          _vm._v("Overdue"),
                        ])
                      : _vm.bookingPaymentIsSent
                      ? _c("span", { staticClass: "label label-info" }, [
                          _vm._v("Sent"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _vm.bookingPaymentIsSent
                  ? _c("p", [
                      _c("i", { staticClass: "fa fa-calendar" }),
                      _vm._v(
                        " Sent On: " +
                          _vm._s(
                            _vm._f("dateTimezone")(
                              _vm.payment.sent_date,
                              _vm.$user.timezone,
                              _vm.$user.date_format_preference,
                              true
                            )
                          )
                      ),
                    ])
                  : _c("p", [
                      _c("i", { staticClass: "fa fa-calendar" }),
                      _vm._v(
                        " Due By: " +
                          _vm._s(
                            _vm._f("dateTimezone")(
                              _vm.payment.due_date,
                              _vm.$user.timezone,
                              _vm.$user.date_format_preference,
                              true
                            )
                          )
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "paymentItem_info" }, [
                _c("div", { staticClass: "paymentItem_price" }, [
                  _vm._v(
                    _vm._s(_vm._f("currency")(_vm.payment.total_inclusive)) +
                      _vm._s(_vm.$showTax ? " (inc tax)" : "")
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "paymentItem_paymentButton",
                    attrs: { type: "button" },
                  },
                  [_vm._v("Make Payment")]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c("booking-edit-payment-due-date-modal", {
                attrs: {
                  "payment-id": _vm.payment.id,
                  "payment-due-date": _vm.payment.due_date,
                  "update-payment": _vm.updatePayment,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }